import React from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
    IconButton,
    InputAdornment,
    Link,
} from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { loginUser } from "../../services/authService";
import { useNavigate } from "react-router-dom";
import { Dialogue } from "./Dialogue";
import SignUpPage from "../sign-up";
import Toast from "../Toast";

const SignIn = () => {
    const [showPassword, setShowPassword] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [toastOpen, setToastOpen] = React.useState(false);  
    const [toastMessage, setToastMessage] = React.useState("");  
    const navigate = useNavigate();

    const validationSchema = Yup.object({
        email: Yup.string().email("Invalid email").required("Email is required"),
        password: Yup.string()
            .min(8, "Password must be at least 8 characters")
            .required("Password is required"),
    });

    const handleTogglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    return (
        <Box
            sx={{
                // height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 2,
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    maxWidth: 400,
                    borderRadius: 4,
                    overflow: "hidden",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                    backgroundColor: "rgba(255, 255, 255, 0.85)",
                    padding: 4,
                    "@media (max-width: 600px)": {
                        padding: 3,
                        maxWidth: "90%",
                    },
                }}
            >
                <Typography
                    variant="h5"
                    align="center"
                    fontWeight="bold"
                    gutterBottom
                    sx={{
                        color: "#333",
                        "@media (max-width: 600px)": {
                            fontSize: "1.5rem",
                        },
                    }}
                >
                    Login
                </Typography>

                <Formik
                    initialValues={{
                        email: "",
                        password: "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                        loginUser(values)
                            .then((res) => {
                                setToastMessage("Login successful!");
                                setToastOpen(true);
                                // navigate('/profile');
                                sessionStorage.setItem('user', JSON.stringify(res.user));
                                document.cookie = `user=${JSON.stringify(res.user) }; path=/; max-age=3600; secure; samesite=strict`;
                                window.location.reload();
                            })
                            .catch((err) => {
                                setToastMessage("Login failed. Please try again.");
                                setToastOpen(true);
                                console.error(err);
                            });
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                    }) => (
                        <Form>
                            <TextField
                                fullWidth
                                placeholder="Email"
                                name="email"
                                value={values.email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.email && Boolean(errors.email)}
                                helperText={touched.email && errors.email}
                                margin="normal"
                            />
                            <TextField
                                fullWidth
                                type={showPassword ? "text" : "password"}
                                placeholder="Password"
                                name="password"
                                value={values.password}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.password && Boolean(errors.password)}
                                helperText={touched.password && errors.password}
                                margin="normal"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={handleTogglePasswordVisibility}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{
                                    backgroundColor: "#d8b035",
                                    color: "white",
                                    marginY: 2,
                                    "&:hover": {
                                        backgroundColor: "#d8b035",
                                    },
                                }}
                            >
                                Login
                            </Button>
                        </Form>
                    )}
                </Formik>

                <Typography align="center" sx={{ marginTop: 2, color: "#333" }}>
                    Don't have an account?{" "}
                    <Link to="" onClick={() => setOpen(true)} sx={{ color: "#333 !important" }}>
                        Sign Up
                    </Link>
                </Typography>
            </Box>
            {open && <Dialogue open={open} onClose={setOpen}><SignUpPage /></Dialogue>}

            <Toast open={toastOpen} message={toastMessage} onClose={() => setToastOpen(false)} />
        </Box>
    );
};

export default SignIn;
